import React from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import { GlobalStyles } from "../styles/global"
import { theme } from "../styles/theme"
import Header from "./header"
import Footer from "./footer"

const Main = styled.main`
  width: 100%;
  min-height: calc(100vh - 320px);
`

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Header />
    <Main>{children}</Main>
    <Footer />
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
